import { tracker } from "./google_tracker.js";

export const api_connect = class {
    api;
    url;
    nonce;
    tracker;
    my_url;
    current_url;
    site_name;
    nonce;
    // is_language_switcher;
    previous_language;
    switch_language;
    // current_position = 0;
    // lang_list = [];

    // constructor(url, nonce) {
    constructor(vue) {
        this.url = vue.url;                             // url serwera z którego ciągnięte sa dane
        this.my_url = this.getStandaloneHost();     // url strony na której stoi vue lub null, jeśli takie samo jak serwer
        this.nonce = typeof(vue.nonce) !== 'undefined' ? vue.nonce : undefined;
        this.api = {
            url:    this.url + '/api/fcwp/v1/url/',
            meta:   this.url + '/api/fcwp/v1/sitemeta/',
        };
        window.tracker = new tracker(vue.$gtm, this.url + '/api/fcwp/v1/omp/');
        this.removeScript();
        this.setHeaders();
    }

    getInitialLanguage() {
        this.previous_language = document.getElementsByTagName('html')[0].lang;
    }

    removeScript() {
        var elem = document.querySelector('#site_data');
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    }

    setHeaders() {
        if (typeof(this.nonce) === 'string') {
            axios.defaults.headers.common['X-WP-Nonce'] = this.nonce;
        }
    }

    getStandaloneHost() {
        var getLocation = function(href) {
            var l = document.createElement("a");
            l.href = href;
            return l;
        };
        var server_location = getLocation(this.url);

        if (location.hostname == server_location.hostname && location.pathname.startsWith(server_location.pathname)) {
            return false;
        }
        return location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '');
    }
    
    async getMeta(language) {
        var params = typeof language !== 'undefined' ? '?lang=' + language : '';
        var data = await axios.get(this.api.meta + params)
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return {'error': error.response.data.message};
            })
            .finally(function () {
                // always executed
            });
        this.site_name = data.name;
        return data;
    }
    
    getClicks(event) {
        var a_element = event.target.closest('a');
        if (!a_element || !a_element.href) return null;
        if (a_element.download) return null;
        event.preventDefault();
        if (a_element.target) {
            window.open(a_element.href, a_element.target);
            return null;
        }
        if (this.isFile(a_element)) {
            // window.location.href = a_element.href;
            // return;

            var filename = a_element.href.substr(a_element.href.lastIndexOf('/') + 1);
            var extension = filename.substr(filename.lastIndexOf('.') + 1);
            a_element.setAttribute('download', filename);
            var data = {
                'action': 'download ' + extension,
                'category': 'fcwp_data',
                'label': filename,
            }
            window.tracker.track(data, 'event');
            a_element.click();
            return null;
        }
        if (this.isDynamicHref(a_element)) {
            return a_element.href;
        } else {
            window.location.href = a_element.href;
        }
    }

    isFile(element) {
        var extension = element.pathname.match(/\.\w{2,4}$/);
        return extension !== null && extension[0] !== '.php' && extension[0] !== '.htm' && extension[0] !== '.html';
    }

    isDynamicHref(element) {
        if (element.getAttribute('synchro') === 'true') {
            window.location.href = element.href;
            return null;
        }

        if (!element.href.startsWith(this.url)) return false;

        var synchronic_urls = [
            this.url + '/wp-admin/',
            this.url + '/wp-content/',
            this.url + '/wp-login.php'
        ];

        for (let url of synchronic_urls) {
            if (element.href.startsWith(url)) return false;
        }
        return true;
    }

    getInitialHref() {
        var initial = location.href;
        return this.my_url ? initial.replace(this.my_url, this.url) : initial;
    }
    
    async getUrl(href, should_push, form_data = null, method = null) {
        this.current_url = href;
        var full_href = href;
        href = href.replace(this.url, '');
        href = href.split('?');

        var path = href[0].split('/');
        path = path.filter(function (el) {
            return el != '';
        });

        var params = {
            'path': path,
            'form': form_data,
            'method': method,
        }
        var gets = href[1] !== undefined ? '?' + href[1] : '';
        var from_api = await axios.post(this.api.url + gets, params)
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return {'error': error.response.data.message};
            })
            .finally(function () {
                // always executed
            });
        if (typeof from_api !== 'object' || from_api === null) {
            var last_line_position = from_api.lastIndexOf("\n");
            var dump = from_api.substr(0, last_line_position);
            var json_string = from_api.substr(last_line_position);
            try {
                from_api = JSON.parse(json_string);
                from_api.content.data_show = dump;
            } catch {
                return {
                    'error': {
                        'dump': dump,
                        'message': json_string,
                    }
                };
            }
        }

        if (from_api.error !== undefined) {
            window.history.pushState(null, 'Error', full_href);
            return from_api;
        }
        if (from_api.content !== undefined) {
            var page_name = this.setPageName(from_api.content.title, from_api.content.is_home);
        }
        if (from_api && should_push) {
            var url_to_push = this.my_url ? from_api.permalink.replace(this.url, this.my_url) : from_api.permalink;
            window.history.pushState(null, page_name, url_to_push);
        }

        window.tracker.track(from_api);

        if (from_api.vars) {
            fcwp_vue_data.vars = from_api.vars;
            delete from_api.vars;
        }
        return from_api;
    }


    setPageName(name, is_home) {
        name = name.replace(/\s*\|\s*/, ' ');
        var doc = new DOMParser().parseFromString(name, 'text/html');
        name = doc.body.textContent;
        var page_name = is_home ? this.site_name : name + ' | ' + this.site_name;
        document.title = page_name;
        return page_name;
    }

}